__turbopack_context__.v({
  "container": "custom-select-module-sass-module__AtXiKG__container",
  "default": "custom-select-module-sass-module__AtXiKG__default",
  "dropdown": "custom-select-module-sass-module__AtXiKG__dropdown",
  "dropdownLoader": "custom-select-module-sass-module__AtXiKG__dropdownLoader",
  "dropdownModal": "custom-select-module-sass-module__AtXiKG__dropdownModal",
  "error": "custom-select-module-sass-module__AtXiKG__error",
  "fieldError": "custom-select-module-sass-module__AtXiKG__fieldError",
  "gradient": "custom-select-module-sass-module__AtXiKG__gradient",
  "maxHeight": "custom-select-module-sass-module__AtXiKG__maxHeight",
  "multipleSelector": "custom-select-module-sass-module__AtXiKG__multipleSelector",
  "value": "custom-select-module-sass-module__AtXiKG__value",
});
